<template>
  <v-container class="start overflow-visible pb-16">

    <router-view />
    <!-- <video-theme-dialog
      v-if="templateId"
      :template-id="templateId"
      @input="$router.push($routeAssign({ params: undefined }))"
    /> -->

    <error-dialog :status="loadStatus" />

    <video-dialog
      hash="#intro"
      poster="https://cdn.ellacard.com/start/group_video_intro_poster.jpg"
      :src="`https://cdn.ellacard.com/start/group_video_intro_hd${IS_MOBILE ? '480' : '720'}.mp4`"
    />

    <!-- Waiting on better video resource, also not sure this really works and it pushes everything below the fold... -->
    <!--
    <div class="mt-6 mb-16 text-center text-sm-left">
      <div
        class="float-sm-right mx-auto ml-sm-6 mb-3 relative"
        :style="$vuetify.breakpoint.xsOnly ? 'max-width: 70%;' : 'max-width: 60%; width: 600px;'"
      >
        <outline-phone>
          <video
            style="cursor: pointer;"
            width="100%"
            playsinline autoplay muted loop
            src="https://cdn.ellacard.com/start/group_video_header_720.mp4"
            srcset="
              https://cdn.ellacard.com/start/group_video_header_720.mp4 720w,
              https://cdn.ellacard.com/start/group_video_header_640.mp4 640w,
              https://cdn.ellacard.com/start/group_video_header_480.mp4 480w,
              https://cdn.ellacard.com/start/group_video_header_320.mp4 320w
            "
            @click="$router.push({ name: $route.name, hash: '#intro' })"
          />
        </outline-phone>
        <v-btn
          style="z-index: 3; right: 7%; bottom: -5%;"
          absolute
          :small="$vuetify.breakpoint.xsOnly"
          @click="$router.push({ name: $route.name, hash: '#intro' })"
        >
          Learn more <v-icon class="ml-2" v-html="mdiVideo" />
        </v-btn>
      </div>

      <h1 class="text-h4 text-md-h3">
        Try our group video maker
      </h1>
      <div class="grey--text text--darken-3 text-sm-h6 my-6">
        <div><v-icon color="green" v-html="mdiAccountGroup" /> Unlimited contributors</div>
        <div class="my-2"><v-icon color="orange" v-html="mdiPencilOff" /> No video editing required</div>
        <div><v-icon color="indigo" v-html="mdiHighDefinitionBox" /> Professional quality themes for any occasion</div>
      </div>
      <div style="clear: both;" />
    </div>
    -->

    <h2 class="mt-6 text-h4 text-md-h3 header-font text-center">What type of video do you want to make?</h2>
    <div class="mx-n2 py-6 py-sm-12 text-center">
      <v-chip
        class="ma-2"
        active-class="primary white--text"
        :disabled="loadStatus.pending && !(!$route.query.q || !$route.query.q.length)"
        :input-value="!$route.query.q || !$route.query.q.length"
        @click="$router.push($routeAssign({ query: { ...$route.query, q: undefined } }))"
      >
        All
      </v-chip>
      <div class="ma-2 d-inline-block btn-group btn-group-horizontal">
        <v-chip
          v-for="[ name, icon ] in FIXED_CHIPS.slice(0, 2)" :key="'chip-' + name"
          active-class="primary white--text"
          :disabled="loadStatus.pending && !queryTerms.includes(name)"
          :input-value="queryTerms.includes(name)"
          @click="toggle(name)"
        >
          <v-icon left v-html="icon" /> {{name}}
        </v-chip>
      </div>
      <v-chip
        v-for="[ name, icon ] in FIXED_CHIPS.slice(2)" :key="'chip-' + name"
        class="ma-2"
        active-class="primary white--text"
        :disabled="loadStatus.pending && !queryTerms.includes(name)"
        :input-value="queryTerms.includes(name)"
        @click="toggle(name)"
      >
        <v-icon left v-html="icon" /> {{name}}
      </v-chip>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-chip
            v-on="on"
            class="ma-2"
            active-class="primary white--text"
            :disabled="loadStatus.pending && !queryTerms.filter(x => !FIXED_CHIPS.map(y => y[0]).includes(x)).length"
            :input-value="queryTerms.filter(x => !FIXED_CHIPS.map(y => y[0]).includes(x)).length > 0"
          >
            More…
            <v-icon right v-html="mdiChevronDown" />
          </v-chip>
        </template>
        <v-list dense>
          <template
            v-for="[ name, icon, iconColor, textClass, isDefault ] in categories"
            v-if="name != 'Template'"
          >
            <v-list-item v-if="name" :input-value="queryTerms.includes(name)" @click="toggle(name)">
              <v-list-item-icon>
                <v-icon :color="iconColor" v-html="icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  :class="textClass + (isDefault ? '' : ' font-weight-bold')"
                  :inner-html.prop="name | category"
                />
              </v-list-item-content>
            </v-list-item>
            <v-divider v-else class="my-2" />
          </template>
        </v-list>
      </v-menu>
    </div>

    <div class="mt-6 grid-alternate dense">
      <template v-for="t in templates">

        <router-link
          class="hover-pop d-inline-block overflow-hidden rounded-xl black"
          style="aspect-ratio: 16 / 9; width: min(400px, 100%); max-width: 80vw;"
          :title="t.name + ' video template'"
          :to="{ name: 'video-template', params: { templateId: t.id }, query: $route.query }"
        >
          <!-- <video width="100%" controls playsinline loading="lazy" :poster="t.poster" :src="t.render" /> -->
          <v-img width="100%" :alt="t.name + ' video template poster'" :src="t.poster" />
        </router-link>

        <div>
          <h4 class="mb-3">{{t.name}}</h4>
          <div class="mb-3">{{t.description}}</div>
          <v-btn class="btn-pop" rounded dark large color="ec-blue" :title="t.name + ' video template'" :to="{ name: 'video-template', params: { templateId: t.id }, query: $route.query }">
            Make this video…
          </v-btn>
        </div>
      </template>
    </div>

    <div v-if="foundNothing" class="d-flex flex-column align-center">
      <div class="title grey--text">No video themes found</div>
      <div class="text-center">
        <v-chip v-for="tag in queryTerms" :key="tag" class="ma-2">{{tag | category}}</v-chip>
      </div>
      <v-btn fab small class="mt-4" color="primary" @click="search()">
        <v-icon>{{mdiClose}}</v-icon>
      </v-btn>
      <div class="title mt-8">Can't find the perfect video theme? <a :href="`mailto:ideas@ellacard.com?subject=${encodeURIComponent('Idea for a video theme')}`">Tell us</a> your ideas – we're constantly adding more!</div>
    </div>

    <div v-if="after || loadStatus.pending" class="d-flex justify-center">
      <v-progress-circular
        v-intersect.quiet="entries => (entries[0] || {}).isIntersecting && loadStatus.promise.then(load)"
        class="my-4"
        indeterminate
      />
    </div>

  </v-container>
</template>


<script>
import VideoDialog from '@/components/VideoDialog.vue';
import VideoPlayer from '@/components/VideoPlayer.vue';
import { cache, ssr } from '@/mixins/ssr.js';
import { buildSearchCategories } from '@/utils/categories.js';
import { COUNTRY_CODE } from '@/utils/intl.js';
import LRUCache from '@/utils/lru-cache.js';
import { cleanTag } from '@/utils/tags.js';
import { mdiChevronDown, mdiClose, mdiVideo, mdiImageMultiple, mdiVideoVintage, mdiCakeVariant, mdiCandle, mdiBriefcase, mdiSchool, mdiHeart, mdiHighDefinitionBox, mdiAccountGroup, mdiPencilOff } from '@mdi/js';


const FIXED_CHIPS = [
  // Note that these two are mutually exclusive
  [ 'Slideshow', mdiImageMultiple ],
  [ 'Movie', mdiVideoVintage ],

  [ 'Birthday', mdiCakeVariant ],
  [ 'Memorial', mdiCandle ],
  [ 'Work', mdiBriefcase ],
  [ 'Graduation', mdiSchool ],
  [ 'Romantic', mdiHeart ]
];


export default {
  name: 'catalog-video',

  routerViewMeta: {
    $subtitle: 'Video templates'
  },

  mixins: [ ssr ],

  components: {
    VideoDialog,
    VideoPlayer
  },

  data() {
    return {
      cardWidth: 0,
      queryTerms: [],
      notFound: false,
      templates: [],
      after: null,
      isAdding: null,
      loadStatus: this.$track('load')
    };
  },

  computed: {
    hydrated() {
      return !this.loadStatus.pending;
    },

    categories() {
      return buildSearchCategories(this.global.localCategories);
    },

    foundNothing() {
      return !this.loadStatus.pending && this.templates.length == 0;
    }
  },

  created() {
    Object.assign(this, { FIXED_CHIPS, mdiChevronDown, mdiClose, mdiVideo, mdiHighDefinitionBox, mdiAccountGroup, mdiPencilOff });
  },

  methods: {
    search(q) {
      if (_.isEqual(q, this.queryTerms))
        this.queryTerms = q;
      this.$router.push(this.$routeAssign({ query: { ...this.$route.query, q } }));
    },

    async load() {
      const params = { tags: this.queryTerms.map(cleanTag), after: this.after };
      const key = JSON.stringify(params);
      if (!this.templateCache)
        this.templateCache = new LRUCache(10);
      let result = this.templateCache.get(key);
      if (!result) {
        result = await cache(this.$call)('search-videos', params);
        result.videos = result.videos.map(x => ({
          id: x[0],
          poster: x[1],
          render: x[2],
          name: x[3],
          description: x[4],
          price: x[5],
          max_participants: x[6]
        }));
        this.templateCache.set(key, result);
      }
      this.templates = this.templates.concat(result.videos);
      this.after = result.has_more ? result.videos[result.videos.length - 1].id : null;
    },

    toggle(tag) {
      const existing = this.$route.query.q;
      let q = existing ? Array.isArray(existing) ? existing.slice() : [ existing ] : [];
      if (q.includes(tag)) {
        q = q.filter(x => x != tag);
      } else {
        // Pay attention to mutually exclusive groups
        if (tag == 'Slideshow')
          q = q.filter(x => x != 'Movie');
        else if (tag == 'Movie')
          q = q.filter(x => x != 'Slideshow');
        else
          q = q.filter(x => [ 'Slideshow', 'Movie' ].includes(x));
        q.push(tag);
      }
      this.$router.push(this.$routeAssign({ query: { ...this.$route.query, q } }));
    }
  },

  watch: {
    '$route.query.q': {
      immediate: true,
      handler(v, prev) {
        if ((v || prev) && _.isEqual(v, prev))
          return;
        this.queryTerms = v ? Array.isArray(v) ? v.slice() : [ v ] : [];
        this.templates = [];
        this.after = undefined;
        this.load();
      }
    }
  }
}
</script>
